/** Une clases condicionales (alternativa mínima a clsx, sin dependencia extra). */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
